export default __webpack_public_path__ + "static/media/feature-image4.ee377df6.png";